import React from 'react';
import { BwjBillboard, IBwjBillboardProps } from '../bwj-billboard';

export enum BwjViewState {
  Untouched,
  Loading,
  Error,
  NoSearchResults,
  Ready,
  InProgress,
  Custom,
  PageNotFound,
}

export interface IBwjViewManagerProps {
  state: BwjViewState;
  untouchedState?: IBwjBillboardProps;
  loadingState?: IBwjBillboardProps;
  pageNotFoundState?: IBwjBillboardProps;
  errorState?: IBwjBillboardProps;
  noSearchResultsState?: IBwjBillboardProps;
  customState?: IBwjBillboardProps;
}

/* Merges the defined properties of overwriteProps into hostProps */
const mergeBillboardProps = (hostProps: IBwjBillboardProps, overwriteProps?: IBwjBillboardProps) => {
  if(!overwriteProps) { return hostProps; }

  if(overwriteProps.icon !== undefined) { 
    hostProps.icon = overwriteProps.icon;
    hostProps.graphic = undefined;
  }
  if(overwriteProps.graphic !== undefined) { 
    hostProps.graphic = overwriteProps.graphic;
    hostProps.graphicPortraitOriented = overwriteProps.graphicPortraitOriented;
    hostProps.icon = undefined;
  }
  if(overwriteProps.message !== undefined) { hostProps.message = overwriteProps.message; }
  if(overwriteProps.progress !== undefined) { hostProps.progress = overwriteProps.progress; }
  if(overwriteProps.buttons !== undefined) { hostProps.buttons = overwriteProps.buttons; }

  return hostProps;
};

export const BwjViewManager: React.FunctionComponent<IBwjViewManagerProps> = (props) => {
  const { customState } = props;

  const untouchedState = mergeBillboardProps({
    icon: 'StatusCircleQuestionMark',
    message: 'Nothing selected yet',
  }, props.untouchedState);

  const notFoundState = mergeBillboardProps({
    icon: 'HeartBroken',
    message: 'Page not found or unavailable',
  }, props.pageNotFoundState);

  const loadingState = mergeBillboardProps({
    message: 'Loading - one moment please...',
  }, props.loadingState);
  loadingState.icon = 'spinner';

  const errorState = mergeBillboardProps({
    message: 'An error occurred',
  }, props.errorState);

  const noSearchResultsState = mergeBillboardProps({
    message: 'No results found',
  }, props.noSearchResultsState);

  const isErrorState = () =>
    props.state === BwjViewState.Error ||
    (props.state === BwjViewState.Custom && !customState);

  return (
    <>
    {props.state === BwjViewState.Untouched && <BwjBillboard {...untouchedState} />}
    {props.state === BwjViewState.PageNotFound && <BwjBillboard {...notFoundState} />}
    {props.state === BwjViewState.Loading && <BwjBillboard {...loadingState} />}
    {isErrorState() && <BwjBillboard {...errorState} />}
    {props.state === BwjViewState.NoSearchResults && <BwjBillboard {...noSearchResultsState} />}
    {props.state === BwjViewState.Custom && !!customState && <BwjBillboard {...customState} />}
    {props.state === BwjViewState.Ready ? props.children : null}
    </>
  );
};